import { useEffect, useRef } from "react"
import { useGBPReviewBadge } from "../api/gbpHooks"

export function GBPNavBadge() {
  const { data } = useGBPReviewBadge()
  const prevCountRef = useRef(0)
  const badgeRef = useRef<HTMLSpanElement>(null)

  const count = data?.count ?? 0

  useEffect(() => {
    // Pulse animation when count increases
    if (count > prevCountRef.current && badgeRef.current) {
      badgeRef.current.classList.remove("animate-badge-pulse")
      // Force reflow to restart animation
      void badgeRef.current.offsetWidth
      badgeRef.current.classList.add("animate-badge-pulse")
    }
    prevCountRef.current = count
  }, [count])

  if (count <= 0) return null

  return (
    <span
      ref={badgeRef}
      className="ml-auto flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-medium leading-none text-white"
    >
      {count > 99 ? "99+" : count}
    </span>
  )
}
